import React from 'react'
import PropTypes from 'prop-types'

import { Container } from './style'
import Logo from './logo'

const CertifiedPurchaseTagTestABCard = ({ shouldRender }) =>
  shouldRender && (
    <Container>
      <Logo />
    </Container>
  )

CertifiedPurchaseTagTestABCard.defaultProps = {
  shouldRender: false,
}

CertifiedPurchaseTagTestABCard.propTypes = {
  shouldRender: PropTypes.bool,
}

export default CertifiedPurchaseTagTestABCard
